import { createContext, useEffect, useState } from "react";
import { ENGLISH } from "../translator/translations/english";
import { NORWEGIAN } from "../translator/translations/norwegian";
import { DANISH } from "../translator/translations/danish";
import { SWEDISH } from "../translator/translations/swedish";
import { LATVIAN } from "../translator/translations/latvian";
import { FINNISH } from "../translator/translations/finnish";
import { FRENCH } from "../translator/translations/french";
import { GERMAN } from "../translator/translations/german";

const translations = {
    en: ENGLISH,
    no: NORWEGIAN,
    da: DANISH,
    se: SWEDISH,
    lv: LATVIAN,
    fi: FINNISH,
    de: GERMAN,
    fr: FRENCH,
}

const browserLanguage = interpretLanguageCode(navigator.language || navigator.userLanguage);

function interpretLanguageCode(langCode) {
    const spitLangCode = langCode.split("-")
    if (spitLangCode.length === 0)
        return "en";

    switch (spitLangCode[0]) {
        case "en":
        case "fr":
        case "de":
        case "no":
        case "da":
        case "se":
        // case "lv":
            return spitLangCode[0];
        default:
            return "en";
    }
}

export const LanguageContext = createContext(null);

export function LanguageSettings({ children }) {

    const [language, setLanguage] = useState(localStorage.getItem("language") || interpretLanguageCode(browserLanguage));
    const [translator, setTranslator] = useState({translate: translate});

    useEffect(() => {
        localStorage.setItem("language", language);
        setTranslator({translate: (phraseKey) => translate(phraseKey, language) });
    }, [language]);

    return (<LanguageContext.Provider
        value={{
            language,
            setLanguage,
            translator,
        }}
    >
        {children}
    </LanguageContext.Provider>);
};

function translate(phraseKey, lang = localStorage.getItem("language")) {
    const splitPhraseKey = phraseKey.split("###VARIABLES###");

    if (!translations[lang])
        return "language not suported";

    let translation = translations[lang][splitPhraseKey[0]];

    if (!translation)
        return "no translation for phrase";

    if (translation.length === 0)
        return "no translation for phrase";

    if (splitPhraseKey.length < 2)
        return translation;

    let variables = splitPhraseKey[1].split("###");
    for (let i = 0; i < variables.length; i++) {
        translation = translation.replaceAll("###"+i+"###", variables[i]);
    }

    return translation;
}